import React from "react";
import searchIcon from "../../assets/svg/searchIcon.svg";

const PropertyDetails = ({ url, video }) => {
  return (
    <div className="w-[300px] -mt-12 md:w-[80vw] h-[auto]">
      <div className="flex gap-8 w-full items-center">
        <div className="w-[75%]">
          {!video ? (
            <img src={url} alt="property" className="h-[80vh] object-cover w-full" />
          ) : (
            <video style={{ height: "80vh", width: "100%", margin: "auto", display: "block" }} controls className="mx-auto object-contain">
              <source src={url} alt="" />
            </video>
          )}
        </div>
        <div className="flex gap-4 px-14 py-20 flex-col justify-center bg-white w-[25%] rounded-xl">
          <img src={searchIcon} alt="property" />
          <p className="text-primary text-center cursor-pointer font-semibold text-[14px]">Click on an item in the image to view details</p>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetails;
